import React, { useEffect } from "react";
import useIsLoading from "../hooks/useIsLoading";

const Loading = () => {
  const { isLoading } = useIsLoading();

  return (
    isLoading && (
      <div
        id="loading-progress"
        className="d-flex justify-content-center"
        style={{
          zIndex: 9000,
          right: 0,
          bottom: 0,
          top: 0,
          left: 0,
          position: "absolute",
          opacity: 1,
        }}
      >
        <div className="mt-4">
          <div className="spinner-border text-primary pt-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <span className="text-black fs-1 ms-3">Loading...</span>
        </div>
      </div>
    )
  );
};

export default Loading;
